import { initComponent } from './core/init-component.js'
import { bindAll } from './utils/bind-all.js'
import { gsap } from '../components/src/gsap.js'
import { Swiper } from 'swiper'
import { Navigation } from 'swiper/modules'

initComponent('.js-ff', section => {
  const header = section.querySelector('.js-ff-header')
  const hero = section.querySelector('.js-ff-hero')
  const heroBg = section.querySelectorAll('.js-ff-hero-bg')
  const stage = section.querySelector('.js-ff-questions-stage')
  const questions = Array.from(stage?.querySelectorAll('.js-ff-step') || []) 
  const options = section.querySelectorAll('.js-ff-option')
  const descriptions = section.querySelectorAll('.js-step-option-description')
  const profileContainer = section.querySelector('.js-ff-quiz-results-profile')
  const profiles = profileContainer?.querySelectorAll('.js-result-profile') || []
  const resultsContainer = section.querySelector('.js-ff-quiz-results')  
  const resultsSection = section.querySelector('.js-ff-quiz-results-sections')
  const resultsMain = section.querySelector('.js-ff-quiz-results-main')  
  const resultsLoader = section.querySelector('.js-ff-quiz-results-loader')
  const allSlides = section.querySelectorAll('.js-ff-slide-in')
  const nextBtn = section.querySelector('.js-ff-next')
  const backBtn = section.querySelector('.js-ff-back')
  const submitBtn = section.querySelector('.js-ff-submit')
  const hiddenMedia = section.querySelectorAll('.js-ff-hidden-media')
  let lockMedia = false
  let isEditing = false
  let swiper = null
  let swiperInitialized = false
  let exitContentListenersAdded = false

  const progressBar = section.querySelector('.js-ff-progress')
  const progressFill = stage?.querySelector('.js-ff-progress-fill')
  const currentEl = stage?.querySelector('.js-ff-progress-current')
  const totalQuestions = questions?.length
  const bgEls = Array.from(section.querySelectorAll('.js-ff-question-bg'))
  const bgDefault = section.querySelector('.js-ff-question-bg-default')
  const scrollDownOnSelect = section.dataset.scrollDownOnSelect === 'true'

  let currentIdx = 0
  const scores = {}
  const answers = {}
  const profileTexts = []

  const pushToDataLayer = (eventData) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(eventData)
  }  

  const moveSectionsToResults = () => {      
    const sections = document.querySelectorAll('.shopify-section')
    
    if (!sections.length || !resultsMain) return
  
    sections.forEach(sec => {         
      if (!sec.contains(section)) {
        const wrapper = document.createElement('div')
  
        while (sec.firstChild) {
          wrapper.appendChild(sec.firstChild)
        }
  
        resultsSection.appendChild(wrapper)
      }
    })
  }
  moveSectionsToResults()  

  const reorderProfiles = () => {
    const sorted = Array.from(profiles).sort((a, b) => {
      const orderA = parseInt(a.dataset.order || '9999', 10)
      const orderB = parseInt(b.dataset.order || '9999', 10)
      return orderA - orderB
    })
    sorted.forEach(el => profileContainer.appendChild(el))
  }
  reorderProfiles()

  const saveResultsToUrl = (ranked) => {
    const params = new URLSearchParams(window.location.search)
    const quizContextEl = section.querySelector('.js-ff-quiz-context')
    if (quizContextEl && quizContextEl.value) {
      params.set('ff_context', quizContextEl.value)
    }
    params.set('ff_results', '1')
    params.set('ff_products', ranked.map(p => p.id).join(','))
    params.set('ff_profiles', profileTexts.join(','))
    const newUrl = `${window.location.pathname}?${params.toString()}`
    history.replaceState({}, '', newUrl)
  }
  
  const checkResultsFromUrl = () => {
    const params = new URLSearchParams(window.location.search)
    if (params.get('ff_results') !== '1') return false
    
    hiddenMedia.forEach(m => m.classList.remove('hidden'))
    resultsLoader?.classList.add('hidden')
    resultsContainer?.classList.add('is-active')
    resultsMain?.classList.add('is-active')

    const productsParam = params.get('ff_products')
    const profilesParam = params.get('ff_profiles')

    const productIds = productsParam ? productsParam.split(',').filter(Boolean) : []
    const restoredProfiles = profilesParam ? profilesParam.split(',').filter(Boolean) : []

    if (productIds.length) {
      answers[0] = { products: productIds.map(id => ({ id })) }
    }

    profileTexts.splice(0, profileTexts.length, ...restoredProfiles)     

    const contextParam = params.get('ff_context')
    
    if (contextParam) {
      hideElementOnContext(contextParam === 'for_someone_else' ? 'For someone else' : 'For me')
    }

    const mainSlideIn = resultsMain.querySelector('.js-ff-slide-in')
    
    setTimeout(() => {      
      header?.classList.add('is-active')
      mainSlideIn?.classList.add('is-active')
    }, 300)
        
    return true
  }

  const hideElementOnContext = (type) => {
    const titles = document.querySelectorAll('.js-ff-title')
    titles.forEach(t => {
      const primary = t.querySelector('.js-ff-for-me')
      const secondary = t.querySelector('.js-ff-for-someone-else')
  
      if (!primary || !secondary) {        
        return
      }      
  
      if (type === 'For someone else') {
        primary.classList.add('hidden')
        secondary.classList.remove('hidden')    
        t.setAttribute('data-question', secondary.textContent)
      } else if (type === 'For me') {
        primary.classList.remove('hidden')
        secondary.classList.add('hidden') 
        t.setAttribute('data-question', primary.textContent)
      }
    })
  
    descriptions.forEach(t => {
      const primary = t.querySelector('.js-ff-for-me')
      const secondary = t.querySelector('.js-ff-for-someone-else')
  
      if (!primary || !secondary) {
        return
      }
  
      if (type === 'For someone else') {
        primary.classList.add('hidden')
        secondary.classList.remove('hidden')
      } else if (type === 'For me') {
        primary.classList.remove('hidden')
        secondary.classList.add('hidden')
      }
    })
  
    const resultsSections = resultsMain.querySelectorAll('section.js-ff-for-me, section.js-ff-for-someone-else')        
    resultsSections.forEach(el => {  
      if (type === 'For someone else') {
        if (el.classList.contains('js-ff-for-me')) {
          el.classList.add('hidden')
        } else if (el.classList.contains('js-ff-for-someone-else')) {
          el.classList.remove('hidden')
        }
      } else if (type === 'For me') {
        if (el.classList.contains('js-ff-for-me')) {
          el.classList.remove('hidden')
        } else if (el.classList.contains('js-ff-for-someone-else')) {
          el.classList.add('hidden')
        }
      }
    })
      
    profiles.forEach(profile => {      
      const primary = profile.querySelector('.js-ff-for-me')
      const secondary = profile.querySelector('.js-ff-for-someone-else')
          
      if (type === 'For someone else') {
        if (secondary) {
          if (primary) primary.classList.add('hidden')
          secondary.classList.remove('hidden')
        } else if (primary) {
          primary.classList.remove('hidden')
        }
      } else if (type === 'For me') {
        if (primary) {
          primary.classList.remove('hidden')
        }
        if (secondary) {
          secondary.classList.add('hidden')
        }
      }
    })       

    const quizContextEl = section.querySelector('.js-ff-quiz-context')    
    if (quizContextEl) {
      if (type === 'For someone else') {
        quizContextEl.value = 'for_someone_else'
      } else if (type === 'For me') {
        quizContextEl.value = 'for_me'
      }      
    }
  }
  
  const equalizeSizes = container => {
    const btns = container.querySelectorAll('.js-ff-option')
    if (!btns.length) return

    const isDesktop = window.matchMedia('(min-width: 1024px)').matches
    const isLargeDesktop = window.matchMedia('(min-width: 1440px)').matches
    const hasDescription = container.querySelector('.js-step-option-description') !== null

    if (!isDesktop) {
      btns.forEach(b => {
        if (isLargeDesktop) {
          b.style.minWidth = 0
        }
        b.style.minHeight = 0
      })

      return
    }

    btns.forEach(b => {
      b.style.minWidth = ''
      b.style.minHeight = ''
      b.style.height = 'auto'
    })

    let maxW = 0
    let maxH = 0

    btns.forEach(b => {
      const rect = b.getBoundingClientRect()
      const style = getComputedStyle(b)
      const padX = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)

      const fullW = rect.width + padX
      const fullH = rect.height + (isDesktop && hasDescription ? 36 : 0)

      maxW = Math.max(maxW, fullW)
      maxH = Math.max(maxH, fullH)

      if (maxW < 287) {
        maxW = 287
      }
    })

    btns.forEach(b => {
      if (isLargeDesktop) {
        b.style.minWidth = Math.ceil(maxW) + 'px'
      }
      b.style.minHeight = Math.ceil(maxH) + 'px'
    })
  }

  const initOptionAnimations = () => {
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches

    options.forEach(option => {
      const desc = option.querySelector('.js-step-option-description')
      if (!desc) return

      const copy = desc.querySelector('.ff__option__description__copy')

      if (isDesktop) {
        gsap.set(desc, { clearProps: 'all' })
        gsap.set(copy, { clearProps: 'all' })
        return
      }

      gsap.set(desc, { height: 0, overflow: 'hidden' })
      gsap.set(copy, { y: 20, opacity: 0 })

      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.attributeName === "class") {
            const isActive = option.classList.contains('active')

            if (isActive) {
              gsap.set(copy, { y: 0, opacity: 1 })
              const targetHeight = desc.scrollHeight
              gsap.set(copy, { y: 20, opacity: 0 })

              gsap.fromTo(desc,
                { height: 0 },
                {
                  height: targetHeight,
                  duration: 0.3,
                  ease: "power1.inOut",
                  onComplete: () => gsap.set(desc, { height: "auto" })
                }
              )

              gsap.to(copy, {
                y: 0,
                opacity: 1,
                duration: 0.3,
                ease: "power1.inOut"
              })

            } else {
              gsap.to(copy, {
                y: 20,
                opacity: 0,
                duration: 0.2,
                ease: "power1.inOut"
              })

              gsap.to(desc, {
                height: 0,
                duration: 0.3,
                ease: "power1.inOut"
              })
            }
          }
        })
      })

      observer.observe(option, { attributes: true })
    })
  }
  initOptionAnimations()

  const pad2 = n => String(n).padStart(2, '0')
  const updateProgress = () => {
    const pct = ((currentIdx + 1) / (totalQuestions + 1)) * 100
    progressFill.style.width = `${pct}%`
    currentEl.textContent = pad2(currentIdx + 1)
  }

  const hideAll = () => {
    hero?.classList.remove('is-active')
    stage?.classList.remove('is-active')
    resultsContainer?.classList.remove('is-active')
    resultsContainer?.classList.add('hidden')
    resultsLoader?.classList.remove('is-active')
    resultsMain?.classList.remove('is-active')
    allSlides.forEach(s => s.classList.remove('is-active'))    
  }

  const resetAnimations = (slide) => {    
    const animEls = slide.querySelectorAll('.js-ff-fade-in, .js-ff-slide-in')
    animEls.forEach(el => {
      el.classList.remove('is-active')
    })
  }

  const resetBackgrounds = () => {
    bgEls.forEach(el => el.classList.remove('is-active'))
    if (bgDefault) bgDefault.classList.add('is-active')
  }
        
  const waitForHeroVideoLoad = () => {
    return new Promise(resolve => {
      const video = section.querySelector('.js-ff-hero video')
      if (!video) return resolve()
  
      if (video.readyState >= 4) {
        requestAnimationFrame(resolve)
        return
      }
  
      const onReady = () => {
        if (video.readyState >= 4) {
          video.removeEventListener('canplaythrough', onReady)
          requestAnimationFrame(resolve)
        }
      }
  
      video.addEventListener('canplaythrough', onReady)
    })
  }

  const showHero = () => {
    hero?.classList.remove('hidden')

    waitForHeroVideoLoad().then(() => {      
      heroBg.forEach(bg => bg.classList.add('is-active'))
    })
    
    section.scrollTo({
      top: 0,
      behavior: 'auto'
    })
   
    hideAll()
    resetBackgrounds()
    header?.classList.add('is-active')
    hero?.classList.add('is-active')
    const heroSlide = hero?.querySelector('.js-ff-slide-in')
    if (heroSlide) {
      requestAnimationFrame(() => {
        heroSlide.classList.add('is-active')
      })
    }

    pushToDataLayer({
      'event': 'ff_start'
    });
  }

  const showQuestionAt = (idx, editing = false) => {
    resetBackgrounds()

    const current = questions[currentIdx]
    const next = questions[idx]
    const nextContent = next.querySelector('.js-ff-slide-in')

    nextContent.classList.remove('is-active')    

    setTimeout(() => {
      removeActiveOptions()
    }, 350)    
    
    
    nextBtn.disabled = true
    submitBtn.disabled = true

    if (current && current !== next) {
      const currentContent = current.querySelector('.js-ff-slide-in')

      if (currentContent) {
        currentContent.classList.remove('is-active')
        currentContent.classList.add('js-ff-slide-out')        
        
        setTimeout(() => {
          current.classList.add('hidden')
          currentContent.classList.remove('js-ff-slide-out')

          next.classList.remove('hidden')          

          if (nextContent) {
            nextContent.classList.remove('is-active')
            void nextContent.offsetHeight
            requestAnimationFrame(() => {
              nextContent.classList.add('is-active')

              requestAnimationFrame(() => {
                equalizeSizes(next)
              })
            })
          }
        }, idx === 0 || editing ? 0 : 300)
      }
    } else {      
      questions.forEach((q, i) => q.classList.toggle('hidden', i !== idx))
      
      if (nextContent) {                
        void nextContent.offsetHeight
        requestAnimationFrame(() => {
          nextContent.classList.add('is-active')
          requestAnimationFrame(() => {
            equalizeSizes(next)
          })
        })
      }
    }

    currentIdx = idx
    updateProgress()
    lockMedia = false

    pushToDataLayer({
      'event': 'ff_question',
      'ff_data': {
        'step': currentIdx + 1,
        'question': questions[currentIdx]?.dataset.question || '',
      } 
    });
  }

  const startQuestions = () => {
    hiddenMedia.forEach(m => m.classList.remove('hidden'))
    stage.classList.add('is-active')       
    resetAnimations(hero)
    showQuestionAt(0)  
  }

  const showResults = () => {    
    section.scrollTo({
      top: 0,
      behavior: 'auto'
    })

    setTimeout(() => {
      removeActiveOptions()
    }, 350)   

    const mainSlideIn = resultsMain.querySelector('.js-ff-slide-in')
    mainSlideIn.classList.remove('is-active')
    hero.classList.remove('is-active')
    stage.classList.remove('is-active')
    
    resultsMain.classList.remove('is-active')    
    resultsContainer.classList.remove('hidden')
    resultsContainer.classList.add('is-active')
    resultsLoader.classList.remove('hidden')

    requestAnimationFrame(() => {
      resultsLoader.classList.add('is-active')
    });

    const exitContent = resultsMain.querySelectorAll('[data-exit-through-content]')
    const sliderContent = resultsMain.querySelectorAll('[data-ff-slide]')

    if (!exitContentListenersAdded) {
      exitContent.forEach(el => {
        el.addEventListener('click', () => {
          pushToDataLayer({
            'event': 'ff_exit_through_content',
            'ff_data': {
              'exit_content_text': el.innerText || '',
            } 
          });
        })
      })

      sliderContent.forEach(el => {
        el.addEventListener('click', () => {
          pushToDataLayer({
            'event': 'ff_finishing_touches',
            'ff_data': {
              'box': el.dataset.ffSlideIndex,
              'title': el.dataset.ffSlideTitle
            } 
          });
        })
      })

      exitContentListenersAdded = true
    }

    if (!checkResultsFromUrl()) {
      setTimeout(() => {      
        resultsLoader.classList.add('hidden')
        resultsContainer.classList.add('is-active')
        resultsMain.classList.add('is-active')
        mainSlideIn.classList.add('is-active')
      }, 2000)
    }    

    const scoreMap = {}

    Object.entries(answers).forEach(([idx, { products }]) => {
      const question = questions[idx]
      const weight = parseFloat(question?.dataset.weight || 1)
    
      products.forEach(p => {
        if (!scoreMap[p.id]) scoreMap[p.id] = { ...p, points: 0 }
        scoreMap[p.id].points += weight
      })
    })

    const ranked = Object.values(scoreMap)
      .sort((a, b) => b.points - a.points)
      .slice(0, 3)     
    
    pushToDataLayer({
      'event': 'ff_end'
    });

    const swiperWrapper = section.querySelector('.js-ff-quiz-results-products')
    if (swiperWrapper) {      
      const allProducts = section.querySelectorAll('.js-ff-result-product')
      allProducts.forEach(el => el.classList.add('!hidden'))
      
      ranked.forEach(p => {
        const el = section.querySelector(`.js-ff-result-product[data-product-id="${p.id}"]`)
        if (el) {
          el.classList.remove('!hidden')
          swiperWrapper.appendChild(el)
        }
      })

      if (!swiperInitialized) {
        const slider = section.querySelector('.js-ff-product-carousel-swiper')
        const prevEl = section.querySelector('.js-slider-prev')
        const nextEl = section.querySelector('.js-slider-next')
        const slidesCount = section.querySelectorAll('.js-ff-result-product').length

        swiper = new Swiper(slider, {
          modules: [Navigation],
          slidesPerView: slidesCount > 1 ? 1.345 : 1,
          spaceBetween: 16,
          slidesPerGroup: 1,
          slidesOffsetBefore: slidesCount > 1 ? 16 : 0,
          slidesOffsetAfter: slidesCount > 1 ? 16 : 0,
          freeMode: false,
          navigation: { prevEl, nextEl },
          breakpoints: {
            1024: {
              slidesPerView: slidesCount > 3 ? 3 : slidesCount,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
              spaceBetween: 32,
            }
          }
        })
        swiperInitialized = true
      } else {
        requestAnimationFrame(() => {
          swiper.update()
          swiper.slideTo(0, 0)
        })
      }
    }
        
    profiles.forEach(el => {
      const profileText = el.dataset.profile
      if (profileTexts.includes(profileText)) {
        el.classList.remove('hidden')
      } else {
        el.classList.add('hidden')
      }
    })       
    
    const recommendedProductsEl = section.querySelectorAll('.js-ff-recommended-products')
    if (recommendedProductsEl.length) {
      const detailedProducts = ranked.map(p => {
        const el = section.querySelector(`.js-ff-result-product[data-product-id="${p.id}"]`)
        if (!el || !el.dataset.productJson) return { id: p.id }
    
        try {
          return JSON.parse(el.dataset.productJson)
        } catch (err) {
          console.error('JSON parsing error:', err, el.dataset.productJson)
          return { id: p.id }
        }
      })
      
      recommendedProductsEl.forEach(el => {
        el.value = JSON.stringify(detailedProducts)
      }) 
    }

    const impressions = ranked.map((p, index) => {
      const el = section.querySelector(`.js-ff-result-product[data-product-id="${p.id}"]`)
      if (!el) return null

      let productData = {}
      try {
        productData = JSON.parse(el.dataset.productJson || '{}')
      } catch (err) {
        console.error('Error parsing product JSON:', err)
        return null
      }

      return {
        'id': productData.variant_sku || '',
        'name': productData.title || '',
        'brand': productData.brand || '',
        'variant': productData.variant_title || '',
        'price': productData.price,
        'list': '/pages/fragrance-finder',
        'product_id': productData.id || '',
        'variant_id': productData.variant_id || '',
        'compare_at_price': productData.compare_at_price || null,
        'image': productData.image || ''
      }
    }).filter(Boolean)

    if (impressions.length > 0) {
      pushToDataLayer({
        'event': 'dl_view_item_list',
        'ecommerce': {
          'currencyCode': window.Shopify?.currency?.active || 'GBP',
          'impressions': impressions
        }
      })
    }
          
    const newsletter = section.querySelector('.js-ff-newsletter')    
    newsletter.classList.remove('ff-newsletter--success')
    saveResultsToUrl(ranked)

    const quizUrlEl = section.querySelectorAll('.js-ff-quiz-url')  
    quizUrlEl.forEach(el => {
      el.value = window.location.href
    })
  }

  if (checkResultsFromUrl()) {    
    showResults()
  } else {
    showHero()
  }

  bindAll(section, '.js-ff-hero-cta', 'click', () => {
    startQuestions()
  })

  bindAll(section, '.js-ff-back', 'click', () => {
    if (!stage.classList.contains('is-active')) {
      return
    }

    const lastIdx = currentIdx - 1
    if (lastIdx >= 0 && answers[lastIdx]) {
      const { profileIdx } = answers[lastIdx]

      if (profileIdx) {
        const idx = profileTexts.lastIndexOf(profileIdx)
        if (idx !== -1) profileTexts.splice(idx, 1)
      }

      delete answers[lastIdx]
    }

    if (lastIdx >= 0) {
      showQuestionAt(lastIdx)
    } else {
      showHero()
    }
  })  

  const selectOption = (opt) => {
    const type = opt.dataset.optionType
    const profileIdx = opt.dataset.profile 
    const mediaIdx = opt.dataset.bgIndex
  
    if (mediaIdx) {
      lockMedia = true
    }        

    hideElementOnContext(type)
  
    const products = JSON.parse(opt.dataset.products || '[]')    
  
    answers[currentIdx] = { products, profileIdx }
  
    if (profileIdx) {
      profileTexts[currentIdx] = profileIdx
    }    

    pushToDataLayer({
      'event': 'ff_answer',
      'ff_data': {
        'step': currentIdx + 1,
        'answer': opt.dataset.optionTitle || '',
      } 
    });
  
    const next = currentIdx + 1
    if (next < totalQuestions) {
      showQuestionAt(next)
    } else {
      if (!isEditing) {
        showResults()
      }
    }
  
    section.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  const removeActiveOptions = () => {
    const activeOptions = stage.querySelectorAll('.js-ff-option.active')
    activeOptions.forEach(o => o.classList.remove('active'))
  }

  bindAll(section, '.js-ff-option', 'click', e => {
    const opt = e.currentTarget
    if (!opt || !stage.classList.contains('is-active')) {
      return
    }

    const idx = opt.dataset.bgIndex || 0
    bgEls.forEach(el => el.classList.remove('is-active'))
    const active = section.querySelector(`.js-ff-question-bg[data-bg-index="${idx}"]`)
    if (active) active.classList.add('is-active')

    nextBtn.disabled = false
    submitBtn.disabled = false
    const isMobile = window.matchMedia('(max-width: 1023px)').matches
    
    
    if (isMobile && scrollDownOnSelect) {      
      setTimeout(() => {
        section.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        })
      }, 320)      
    }

    if (isMobile || isEditing) {      
      removeActiveOptions()
      opt.classList.add('active')
      lockMedia = true
      return
    }

    selectOption(opt)
  })
                            
  bindAll(section, '.js-ff-next', 'click', e => {
    const opt = stage.querySelector('.js-ff-step-option.active')
    selectOption(opt)
    if (window.scrollY > 0) {
      section.scrollTo({ top: 0, behavior: 'smooth' })
    }
    nextBtn.disabled = true
  })

  bindAll(section, '.js-ff-option', 'mouseenter', e => {
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches
    if (!isDesktop) return 

    const option = e.currentTarget
    const idx = option.dataset.bgIndex || 0

    bgEls.forEach(el => el.classList.remove('is-active'))
    const active = section.querySelector(`.js-ff-question-bg[data-bg-index="${idx}"]`)
    if (active) active.classList.add('is-active')
  })

  bindAll(section, '.js-ff-option', 'mouseleave', (event) => {
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches
    if (!isDesktop) return

    const selected = stage.querySelector('.js-ff-option.active')
    if (!selected) {
      resetBackgrounds()
      return
    }

    const idx = selected.dataset.bgIndex || 0

    bgEls.forEach(el => el.classList.remove('is-active'))
    const activeBg = section.querySelector(`.js-ff-question-bg[data-bg-index="${idx}"]`)
    if (activeBg) activeBg.classList.add('is-active') 
  })
    
  const toggleNavButtons = (showSubmit) => {
    if (showSubmit) {
      progressBar.classList.add('hidden')
      backBtn.classList.add('hidden')
      nextBtn.classList.add('hidden')
      submitBtn.classList.remove('hidden')
      submitBtn.disabled = true      
    } else {
      progressBar.classList.add('hidden')
      backBtn.classList.remove('hidden')
      nextBtn.classList.remove('hidden')
      submitBtn.classList.add('hidden')
    }    
  }  

  bindAll(section, '.js-result-profile-link', 'click', e => {
    e.preventDefault()
    const parent = e.currentTarget.closest('.js-result-profile')
    if (!parent) return
  
    const questionIdx = parseInt(parent.dataset.question, 10)    
    if (isNaN(questionIdx)) return

    questions.forEach(q => {
      q.classList.add('hidden')
      const slide = q.querySelector('.ff__questions')
      
      if (slide) {
        slide.classList.remove('is-active')
      }
    })
          
    requestAnimationFrame(() => {
      isEditing = true
      hideAll()
      stage.classList.add('is-active')
      showQuestionAt(questionIdx, true)    
      toggleNavButtons(true)    
      history.replaceState({}, '', window.location.pathname)
    })
  })

  bindAll(section, '.js-ff-submit', 'click', e => {
    e.preventDefault()
      
    const activeOpt = questions[currentIdx].querySelector('.js-ff-option.active')
    if (activeOpt) {
      selectOption(activeOpt)
    }
  
    showResults()
    
    toggleNavButtons(false)
    isEditing = false
  
  })
  
  let lastWidth = window.innerWidth

  window.addEventListener('resize', () => {
    const newWidth = window.innerWidth
    if (newWidth === lastWidth) return 
    lastWidth = newWidth

    const active = questions[currentIdx]
    initOptionAnimations()
    if (active && !active.classList.contains('hidden')) {
      equalizeSizes(active)
    } else {
      equalizeSizes()
    }

    removeActiveOptions()
  })

  bindAll(section, '.js-ff-start-again', 'click', e => {
    for (const key in scores) delete scores[key]
    for (const key in answers) delete answers[key]
    profileTexts.length = 0

    const allProducts = section.querySelectorAll('.js-ff-result-product')
    allProducts.forEach(el => el.classList.add('!hidden'))
    
    profiles.forEach(el => el.classList.add('hidden'))

    hideAll()

    pushToDataLayer({
      'event': 'ff_restart' 
    });
    
    showHero()    

    history.replaceState({}, '', window.location.pathname)
  })
    
  bindAll(section, '.js-ff-email-my-results', 'click', () => {
    const allTargets = Array.from(section.querySelectorAll('.js-ff-newsletter'))
    const visibleTarget = allTargets.find(el => el.offsetParent !== null)

    if (visibleTarget) {
      visibleTarget.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    pushToDataLayer({
      'event': 'ff_email'
    });
  })

  return {
    unload() {
      swiper.destroy()
    },
    selectBlock(block) {
      const qIndex = parseInt(block?.dataset?.questionIndex, 10)
      if (!isNaN(qIndex)) {
        startQuestions()
        const idx0 = Math.max(0, Math.min(totalQuestions - 1, qIndex - 1))
        showQuestionAt(idx0)
      }
      return () => { }
    }
  }
})
